import { render, staticRenderFns } from "./IconSvgNextGen2.vue?vue&type=template&id=96f3d58e&scoped=true&"
import script from "./IconSvgNextGen2.vue?vue&type=script&lang=js&"
export * from "./IconSvgNextGen2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f3d58e",
  null
  
)

export default component.exports